import React from 'react'
import { Controller } from 'react-hook-form'
import { TextField, Grid } from '@material-ui/core'

const CityTextField = ({ input, control, setValue, errors = {} }) => {
  return (
    <Grid
      item
      xs={input?.width[0] || 12}
      sm={input?.width[1] || 12}
      md={input?.width[2] || 12}
      lg={input?.width[3] || 12}
      key={input.id}
    >
      <Controller
        name={input?.name}
        control={control}
        as={
          <TextField
            type="text"
            label={input?.labelName}
            variant={input?.field?.variant}
            fullWidth={input?.field?.fullWidth}
            required={input?.field?.required}
            size={input?.field?.size}
            placeholder={input?.field?.placeholder}
            error={!!errors?.name}
            helperText={errors?.name?.message}
          />
        }
        onChange={(e) => {
          setValue(input.name, e[0]?.target?.value)
          return e[0]?.target?.value
        }}
      />
    </Grid>
  )
}

export default CityTextField
